import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { equipmentVwMdl } from './entities/equipment/model';
import { TopMenu } from './entities/menu/model';
import { Customer, Equipment, JobSite, Family, Make, Model, CurrentSelection, luUCIInventoryStatusModel, EquipmentModelVm } from './entities/global/model';
import { AppRoute, AppUris } from './entities/app-config/model';
import { SearchItem, SearchFavorite, SearchFavoriteOperation } from './entities';
import { Title } from '@angular/platform-browser';
import { catchError, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ViewedInspectionTypes } from './modules/inspection/models/find-inspection.model';
import { CustomeEvaluationRangeVM } from './modules/CustomEval/custom-eval.model';
import { ColourScheme, DealerGroupBrandingV, DealerGroupV } from './modules/GET_NEW_UI/setup-implement/setup-implement.model';
import { ReportConfigurationViewModel } from './modules/GET_NEW_UI/dashboard/dashboard.model';
import { ActionHistoryComponentData, EquipmentModel } from './modules/manage-components/manage-components.model';

@Injectable()
export class AppService implements OnInit {
    /* Keeps track of if the search component is expanded or not */
    private _searchComponentIsExapanded: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _widgetTriggerSubject: BehaviorSubject<string> = new BehaviorSubject('');
    public readonly searchComponentIsExpanded: Observable<boolean> = this._searchComponentIsExapanded.asObservable();
    private pageComponentsTurnOffSubject = new Subject<string>();
    /* Keeps track of if the date inputs should be visible in the search component */
    private _showSearchComponentDateInputs: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public readonly showSearchComponentDateInputs: Observable<boolean> = this._showSearchComponentDateInputs.asObservable();


    private defaultViewing = ViewedInspectionTypes.GeneralInspection;
    private _showUserFilter: BehaviorSubject<ViewedInspectionTypes> = new BehaviorSubject(this.defaultViewing);
    public readonly showUserFilter: Observable<ViewedInspectionTypes> = this._showUserFilter.asObservable();

    public RequestResult = true;
    private ErrorResponse: any;
    private routeCallbackSubject = new Subject<AppRoute>(); // Source
    private selectionCallbackSubject = new Subject<CurrentSelection>(); // Source
    private selectionSearchItemsCallbackSubject = new Subject<SearchItem[]>(); // Source
    private appUriCallBackSubject = new Subject<AppUris>();
    private usernameSubject = new Subject<string>();
    private _topMenu: TopMenu = new TopMenu();
    private _currentRoute = new AppRoute();
    private _menuIsSet = false;
    private _lastSelection: CurrentSelection;
    private enableTabs = false;
    private _lastSelectionSearchItems: SearchItem[] = [
        { Id: 8, SearchId: 1, SearchStr: '', Title: 'Evaluation A' },
        { Id: 9, SearchId: 1, SearchStr: '', Title: 'Evaluation B' },
        { Id: 10, SearchId: 1, SearchStr: '', Title: 'Evaluation C' },
        { Id: 11, SearchId: 1, SearchStr: '', Title: 'Evaluation X' },
        { Id: 12, SearchId: -1, SearchStr: this.defaultSearchStartDate.toISOString(), Title: 'Start Date' },
        { Id: 13, SearchId: -1, SearchStr: this.defaultSearchEndDate.toISOString(), Title: 'End Date' },
        { Id: 24, SearchId: 7, SearchStr: '', Title: 'Status' },
        { Id: 26, SearchId: 1, SearchStr: '', Title: 'Evaluation MR' },
        { Id: 27, SearchId: 1, SearchStr: '', Title: 'Evaluation M' }];
    private _newUIRouteIds = [
        //  { linkId: 1, level: 1, label: 'Dashboard' },
        { linkId: 42, level: 2, label: 'Setup Undercarriage' },
        { linkId: 14, level: 3, label: 'On Equipment' },
        { linkId: 15, level: 3, label: 'In inventory' },
        { linkId: 10, level: 2, label: 'Setup New Equipment' },
        { linkId: 31, level: 2, label: 'Preferences' },
        { linkId: 2, level: 2, label: 'Find & Edit Inspection' },
        { linkId: 17, level: 3, label: 'Measurement Points' },
        { linkId: 1, level: 2, label: 'New Inspection' }, // todo
        { linkId: 15, level: 2, label: 'Inventory' },
        { linkId: 22, level: 2, label: 'Fleet Component Forecast' },
        { linkId: 8, level: 3, label: 'Setup Families' },
        { linkId: 11, level: 3, label: 'Setup Models' },
        { linkId: 45, level: 2, label: 'Observation Lists' },
        { linkId: 46, level: 2, label: 'Customer Notes' },
        { linkId: 38, level: 2, label: 'About' },
        { linkId: 47, level: 2, label: 'Manage Inspection Types' },
        { linkId: 7, level: 2, label: 'RecordAction' },
        { linkId: 48, level: 2, label: 'Setup Evaluation Ranges' },
        { linkId: 49, level: 2, label: 'New WSRE Inspection' },
        { linkId: 50, level: 2, label: 'Manage Training' },
        { linkId: 51, level: 2, label: 'Setup Training Types' },
        { linkId: 52, level: 2, label: 'Setup Training Slides' },
        { linkId: 53, level: 2, label: 'Setup Training Questions' },
        { linkId: 54, level: 2, label: 'Manage Component Criticality' },
        { linkId: 19, level: 2, label: 'Component Life Performance' },
        { linkId: 19, level: 2, label: 'Job Role Permission' },
        /* { linkId: 47, level: 2, label: 'Logout' },*/




    ];
    showSearchbox = [{ routeId: 1, routeLevel: 1 }];

    numberMap = ['okm', 'qaz', 'wsx', 'edc', 'rfv', 'tgb', 'yhn', 'ujm', 'uhb', 'ijn'];
    //   { Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" },
    //   { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" },
    //   { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" },
    //   { Id: 11, SearchId: 1, SearchStr: "", Title: "Evaluation X" },
    //   { Id: 12, SearchId: -1, SearchStr: this.defaultSearchStartDate.toISOString(), Title: "Start Date" },
    //   { Id: 13, SearchId: -1, SearchStr: this.defaultSearchEndDate.toISOString(), Title: "End Date" }];

    // ];
    private _appUris: AppUris = new AppUris();
    private _appUrisLoaded =
        [{ Id: 1, loaded: false, name: 'IdentityServerUri' },
        { Id: 2, loaded: false, name: 'UCUri' },
        { Id: 3, loaded: false, name: 'GETUri' },
        { Id: 4, loaded: false, name: 'oldUCUri' },
        { Id: 5, loaded: false, name: 'oldGETUri' }];
    private _searchItems = [
        { Id: 1, Title: 'Customer' },
        { Id: 2, Title: 'Jobsite' },
        { Id: 3, Title: 'Equipment' },
        { Id: 4, Title: 'Family' },
        { Id: 5, Title: 'Make' },
        { Id: 6, Title: 'Model' },
        { Id: 7, Title: 'System' },
        { Id: 8, Title: 'Evaluation A' },
        { Id: 9, Title: 'Evaluation B' },
        { Id: 10, Title: 'Evaluation C' },
        { Id: 11, Title: 'Evaluation X' },
        { Id: 12, Title: 'Start Date' },
        { Id: 13, Title: 'End Date' },
        { Id: 20, Title: 'Inspector' },
        { Id: 21, Title: 'Dealer' },
        { Id: 22, Title: 'Serial' },
        { Id: 23, Title: 'EqNotInUse' },
        { Id: 24, Title: 'Status' },
        { Id: 26, Title: 'Evaluation MR' },
        { Id: 27, Title: 'Evaluation M' },
    ];

    private actionTypes = [
        { Id: 1, Title: 'Turn' },
        { Id: 2, Title: 'Weld' },
        { Id: 3, Title: 'Replace New' },
        { Id: 4, Title: 'Replace' },
        { Id: 5, Title: 'Swap' },
        { Id: 6, Title: 'Reshell' },
        { Id: 7, Title: 'Remove & Install' },
        { Id: 8, Title: 'Repair Dry Joints' },
        { Id: 9, Title: 'Turn Pins & Bushings' },
        { Id: 10, Title: 'Adjust Tension' },
        { Id: 11, Title: 'Repair Dry Joints' },
        { Id: 12, Title: 'Turn Pins & Bushings' },
        { Id: 13, Title: 'Adjust Tension' },
        { Id: 14, Title: 'Regrouser' },
        { Id: 15, Title: 'Replace with New' },
        { Id: 16, Title: 'Weld Treads' },
        { Id: 17, Title: 'Swap Front/Rear' },
        { Id: 18, Title: 'Replace with New' },
        { Id: 19, Title: 'Replace with New' },
        { Id: 20, Title: 'Reshell' },
        { Id: 21, Title: 'Replace with New' },
        { Id: 22, Title: 'Replace at Turn' },
        { Id: 23, Title: 'Replace at New Link Assembly Time' },
        { Id: 24, Title: 'Replace at Turn' },
        { Id: 25, Title: 'Replace at New Link Assembly Time' },
        { Id: 26, Title: 'Replace at Turn' },
        { Id: 27, Title: 'Replace at New Link Assembly Time' },
        { Id: 28, Title: 'Replace Wear Strips/Assemblies' },
        { Id: 29, Title: 'Replace with New' },
        { Id: 30, Title: 'Replace with New' },
        { Id: 31, Title: 'Replace with New' },
        { Id: 32, Title: 'Insert Inspection' },
        { Id: 33, Title: 'Update Inspection' },
        { Id: 34, Title: 'Replace system from inventory' },
        { Id: 35, Title: 'Replace component with new' },
        { Id: 36, Title: 'Pre-Action' },
        { Id: 37, Title: 'SetupEquipment' },
        { Id: 38, Title: 'Install Component on System while on Equipment' },
        { Id: 39, Title: 'Install System on Equipment' },
        { Id: 40, Title: 'Change Meter Unit' },
        { Id: 41, Title: 'SMU Reading Action' },
        { Id: 99, Title: 'GET-Action' },
        { Id: 10805, Title: 'Repair Component' },
    ];


    //indentity
    private pageTitleSubject = new Subject<string>();
    private pageSubTitleSubject = new Subject<string>();
    private menuVisibleSubject = new Subject<boolean>();

    private menuVisible: boolean = false;

    private readonly GetUndercarriageApiAddress = 'api/menu/getundercarriageurl';
    private readonly GetGetApiAddress = 'api/menu/getgeturl';

    // private pageComponents: string[] = ['menu', ''];

    constructor(private _http: HttpClient, private _titleService: Title) {
        this.loadUsername();
    }

    ngOnInit() {
    }


    showPageComponent(comp: string) {

    }

    /**
     * Updates whether or not the date inputs should be visible.
     * @param {boolean} showDateInputs True if the date inputs should be visible.
     */
    setShowSearchComponentDateInputs(showDateInputs: boolean) {
        this._showSearchComponentDateInputs.next(showDateInputs);
    }


    setShowUserFilter(viewingInspectionTab: ViewedInspectionTypes) {
        this._showUserFilter.next(viewingInspectionTab);
    }

    /**
     * Returns the default start date to be used in the shared
     * search component initially. This date is 3 months before
     * the current date.
     * @returns A date object.
     */
    get defaultSearchStartDate(): Date {
        const date = new Date(Date.now());
        date.setMonth(date.getMonth() - 3);
        return date;
    }

    /**
     * Returns the default end date to be used in the shared
     * search component initially. This date is 1 day ahead of the
     * current date.
     * @returns A date object.
     */
    get defaultSearchEndDate(): Date {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        return date;
    }


    simpleNumberEncrypt(value: number): string {
        const numberStr = value.toString();
        let result = '';
        for (let k = 0; k < numberStr.length; k++) {
            if (k !== 0) result += '-';
            result += this.numberMap[parseInt(numberStr[k])];
        }
        return result;
    }

    simpleNumberDecrypt(value: string): number {
        const numberStr = value.split('-');
        let result = '0';
        for (let k = 0; k < numberStr.length; k++) {
            const index = this.numberMap.findIndex(m => m.toLowerCase() === numberStr[k]);
            if (index >= 0)
                result += index;
            else
                return -1;
        }
        return +result;
    }
    getPhoto() {
        return this._http.get('api/inspection/getphoto').pipe(catchError(this.handleError));
    }

    setPageTitle(title: string) {
        this._titleService.setTitle(title);
    }

    setSearchComponentExpandedStatus(isExpanded: boolean) {
        this._searchComponentIsExapanded.next(isExpanded);
    }

    sendRouteMessage(routeMessage: AppRoute) {
        setTimeout(() => {
            this._currentRoute = routeMessage;
            this.routeCallbackSubject.next(routeMessage);
        }, 5);
    }

    getRouteMessage(): Observable<AppRoute> {
        return this.routeCallbackSubject.asObservable();
    }

    sendWidgetTrigger(current: string) {
        this._widgetTriggerSubject.next(current);
    }


    getWidgetTrigger(): Observable<string> {
        return this._widgetTriggerSubject.asObservable();
    }

    sendSelection(current: CurrentSelection) {
        this._lastSelection = current;
        this.selectionCallbackSubject.next(current);
    }
    sendSelectionSearchItems(current: SearchItem[]) {
        this._lastSelectionSearchItems = current;
        this.selectionSearchItemsCallbackSubject.next(current);
    }



    sendEnableSearch(Val) {
        this.enableTabs = Val
    }
    getEnableSearch(): boolean {
        return this.enableTabs
    }
    getSelection(): Observable<CurrentSelection> {
        return this.selectionCallbackSubject.asObservable();
    }
    getSelectionSearchItems(): Observable<SearchItem[]> {
        return this.selectionSearchItemsCallbackSubject.asObservable();
    }
    getLastSelection(): CurrentSelection {
        return this._lastSelection;
    }
    getLastSelectionSearchItems(): SearchItem[] {
        return this._lastSelectionSearchItems;
    }
    getLastRouteMessage(): AppRoute {
        return this._currentRoute;
    }

    getAppUris(): Observable<AppUris> {
        this.getAppUrisCached();
        return this.appUriCallBackSubject.asObservable();
    }
    getBaseURL(): string {
        return `${location.protocol}//${location.host}/`;
    }
    formatDate(date: Date): string {
        if (!date) return '-';
        date = new Date(date);
        const monthNames = [
            'January', 'February', 'March',
            'April', 'May', 'June', 'July',
            'August', 'September', 'October',
            'November', 'December'
        ];
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();

        return day + ' ' + monthNames[monthIndex] + ' ' + year;
    }

    getEvalCode(value: number): string {
        if (value <= 30) return 'A';
        if (value <= 50) return 'B';
        if (value <= 70) return 'C';
        if (value > 70) return 'X';
    }


    getEvalToolMeasurementPoint(evalSelection: string): number {
        if (evalSelection === 'A') return 15;
        if (evalSelection === 'B') return 40;
        if (evalSelection === 'C') return 60;
        if (evalSelection === 'X') return 80;
        return 0;
    }

    CalculateMiddle(from: number, to: number, isEnableMaxRange: boolean): number {

        if (isEnableMaxRange == true) {
            //let total = (from + to);
            return to;
        } else {
            let total = (from + to);
            return total / 2;
        }

    }
    //new code
    getEvalToolMeasurementPoint_Worn(evalSelection: string, compType: number, Range: CustomeEvaluationRangeVM, isEnableMaxRange: boolean): number {
        if (compType == 230) {
            switch (evalSelection) {
                case 'A':
                    return this.CalculateMiddle(0, Range.LinkA, isEnableMaxRange);
                case 'B':
                    return this.CalculateMiddle(Range.LinkA, Range.LinkB, isEnableMaxRange);
                case 'C':
                    return this.CalculateMiddle(Range.LinkB, Range.LinkC, isEnableMaxRange)
                case 'X':
                    if (isEnableMaxRange == true) {
                        return 100;
                    } else {
                        if (Range.LinkC != null) return Range.LinkC + 5;
                        else return Range.LinkB + 5;
                    }


                default:
                    break;
            }
        }
        if (compType == 231) {
            switch (evalSelection) {
                case 'A':
                    return this.CalculateMiddle(0, Range.BushA, isEnableMaxRange);
                case 'B':
                    return this.CalculateMiddle(Range.BushA, Range.BushB, isEnableMaxRange);
                case 'C':
                    return this.CalculateMiddle(Range.BushB, Range.BushC, isEnableMaxRange)
                case 'X':
                    if (isEnableMaxRange) {
                        return 100;
                    } else {
                        if (Range.BushC != null) return Range.BushC + 5;
                        else return Range.BushB + 5;
                    }


                default:
                    break;
            }
        }
        if (compType == 232) {
            switch (evalSelection) {
                case 'A':
                    return this.CalculateMiddle(0, Range.ShoeA, isEnableMaxRange);
                case 'B':
                    return this.CalculateMiddle(Range.ShoeA, Range.ShoeB, isEnableMaxRange);
                case 'C':
                    return this.CalculateMiddle(Range.ShoeB, Range.ShoeC, isEnableMaxRange)
                case 'X':
                    if (isEnableMaxRange == true) {
                        return 100;
                    } else {
                        if (Range.ShoeC != null) return Range.ShoeC + 5;
                        else return Range.ShoeB + 5;
                    }


                default:
                    break;
            }
        }
        if (compType == 233) {
            switch (evalSelection) {
                case 'A':
                    return this.CalculateMiddle(0, Range.IdlerA, isEnableMaxRange);
                case 'B':
                    return this.CalculateMiddle(Range.IdlerA, Range.IdlerB, isEnableMaxRange);
                case 'C':
                    return this.CalculateMiddle(Range.IdlerB, Range.IdlerC, isEnableMaxRange)
                case 'X':
                    if (isEnableMaxRange == true) {
                        return 100;
                    } else {
                        if (Range.IdlerC != null) return Range.IdlerC + 5;
                        else return Range.IdlerB + 5;
                    }


                default:
                    break;
            }
        }
        if (compType == 234) {
            switch (evalSelection) {
                case 'A':
                    return this.CalculateMiddle(0, Range.CarrierRollerA, isEnableMaxRange);
                case 'B':
                    return this.CalculateMiddle(Range.CarrierRollerA, Range.CarrierRollerB, isEnableMaxRange);
                case 'C':
                    return this.CalculateMiddle(Range.CarrierRollerB, Range.CarrierRollerC, isEnableMaxRange)
                case 'X':
                    if (isEnableMaxRange == true) {
                        return 100;
                    } else {
                        if (Range.CarrierRollerC != null) return Range.CarrierRollerC + 5;
                        else return Range.CarrierRollerB + 5;
                    }


                default:
                    break;
            }
        }
        if (compType == 235) {
            switch (evalSelection) {
                case 'A':
                    return this.CalculateMiddle(0, Range.TrackRollerA, isEnableMaxRange);
                case 'B':
                    return this.CalculateMiddle(Range.TrackRollerA, Range.TrackRollerB, isEnableMaxRange);
                case 'C':
                    return this.CalculateMiddle(Range.TrackRollerB, Range.TrackRollerC, isEnableMaxRange)
                case 'X':
                    if (isEnableMaxRange == true) {
                        return 100;
                    } else {
                        if (Range.TrackRollerC != null) return Range.TrackRollerC + 5;
                        else return Range.TrackRollerB + 5;
                    }


                default:
                    break;
            }
        }
        if (compType == 236) {
            switch (evalSelection) {
                case 'A':
                    return this.CalculateMiddle(0, Range.SprocketA, isEnableMaxRange);
                case 'B':
                    return this.CalculateMiddle(Range.SprocketA, Range.SprocketB, isEnableMaxRange);
                case 'C':
                    return this.CalculateMiddle(Range.SprocketB, Range.SprocketC, isEnableMaxRange)
                case 'X':
                    if (isEnableMaxRange == true) {
                        return 100;
                    } else {
                        if (Range.SprocketC != null) return Range.SprocketC + 5;
                        else return Range.SprocketB + 5;
                    }


                default:
                    break;
            }
        }
        if (compType == 240) {
            switch (evalSelection) {
                case 'A':
                    return this.CalculateMiddle(0, Range.ElongationA, isEnableMaxRange);
                case 'B':
                    return this.CalculateMiddle(Range.ElongationA, Range.ElongationB, isEnableMaxRange);
                case 'C':
                    return this.CalculateMiddle(Range.ElongationB, Range.ElongationC, isEnableMaxRange)
                case 'X':
                    if (isEnableMaxRange == true) {
                        return 100;
                    } else {
                        if (Range.ElongationC != null) return Range.ElongationC + 5;
                        else return Range.ElongationB + 5;
                    }


                default:
                    break;
            }
        }

        if (compType == 417) {
            switch (evalSelection) {
                case 'A':
                    return this.CalculateMiddle(0, Range.CrawlerGuideA, isEnableMaxRange);
                case 'B':
                    return this.CalculateMiddle(Range.CrawlerGuideA, Range.CrawlerGuideB, isEnableMaxRange);
                case 'C':
                    return this.CalculateMiddle(Range.CrawlerGuideB, Range.CrawlerGuideC, isEnableMaxRange)
                case 'X':
                    if (isEnableMaxRange == true) {
                        return 100;
                    } else {
                        if (Range.CrawlerGuideC != null) return Range.CrawlerGuideC + 5;
                        else return Range.CrawlerGuideB + 5;
                    }


                default:
                    break;
            }
        }
        if (compType == 446) {
            switch (evalSelection) {
                case 'A':
                    return this.CalculateMiddle(0, Range.RSRearIdlerA, isEnableMaxRange);
                case 'B':
                    return this.CalculateMiddle(Range.RSRearIdlerA, Range.RSRearIdlerB, isEnableMaxRange);
                case 'C':
                    return this.CalculateMiddle(Range.RSRearIdlerB, Range.RSRearIdlerC, isEnableMaxRange)
                case 'X':
                    if (isEnableMaxRange == true) {
                        return 100;
                    } else {
                        if (Range.RSRearIdlerC != null) return Range.RSRearIdlerC + 5;
                        else return Range.RSRearIdlerB + 5;
                    }


                default:
                    break;
            }
        }
        if (compType == 0)//RSREAR
        {
            switch (evalSelection) {
                case 'A':
                    return 15;
                case 'B':
                    return 40;
                case 'X':
                    return 70
                default:
                    break;
            }

        }

        else {
            switch (evalSelection) {
                case 'A':
                    return 30;
                case 'B':
                    return 50;
                case 'C':
                    return 70
                case 'X':
                    return 100;

                default:
                    break;
            }
        }
    }

    getUserSearchFavorites(moduleid: number): Observable<SearchFavorite[]> {
        const options = {
            params: new HttpParams().set('moduleid', moduleid.toString())
        };
        return this._http.get<SearchFavorite[]>('Api/User/getUserSearchFavorites', options).pipe(catchError(this.handleError));
    }
    getFleetReportConfiguration(): Observable<ReportConfigurationViewModel[]> {
        return this._http.get<ReportConfigurationViewModel[]>('Api/Dashboard/GetFleetReportConfiguration').pipe(catchError(this.handleError));
    }

    getFavoriteItems(favoriteId: number): Observable<SearchItem[]> {
        const options = {
            params: new HttpParams().set('favoriteId', favoriteId.toString())
        };
        return this._http.get<SearchItem[]>('Api/User/getFavoriteSearchItems', options).pipe(catchError(this.handleError));
    }

    addSearchFavorite(favorite: SearchFavorite): Observable<SearchFavoriteOperation> {
        return this._http.post<SearchFavoriteOperation>('Api/User/addSearchFavorite', favorite).pipe(catchError(this.handleError));
    }

    updateSearchFavorite(favorite: SearchFavorite): Observable<SearchFavoriteOperation> {
        return this._http.post<SearchFavoriteOperation>('Api/User/updateSearchFavorite', favorite).pipe(catchError(this.handleError));
    }

    removeSearchFavorite(favorite: SearchFavorite): Observable<SearchFavoriteOperation> {
        return this._http.post<SearchFavoriteOperation>('Api/User/removeSearchFavorite', favorite).pipe(catchError(this.handleError));
    }

    private getAppUrisCached(): void {
        for (let k = 1; k <= 5; k++) {
            const current = this._appUrisLoaded.find(m => m.Id === k);
            if (/*!current.loaded*/true) {
                this.getApplicationConfigValue(current.name).subscribe(result => {
                    this.setAppUriById(k, result); this._appUrisLoaded.find(m => m.Id === k).loaded = true;
                    if (this._checkAppUrisAll()) { this.appUriCallBackSubject.next(this._appUris); return; }
                });
            } /*else {
                if (this._checkAppUrisAll())
                { this.appUriCallBackSubject.next(this._appUris); return; }
            }*/
        }
    }

    private setAppUriById(Id: number, value: string) {
        switch (Id) {
            case 1: this._appUris.IdentityServerUri = value;
                break;
            case 2: this._appUris.UCUri = value;
                break;
            case 3: this._appUris.GETUri = value;
                break;
            case 4: this._appUris.oldUCUri = value;
                break;
            case 5: this._appUris.oldGETUri = value;
                break;
        }
    }

    private _checkAppUrisAll(): boolean {
        for (let k = 1; k <= 5; k++) {
            if (!this._appUrisLoaded.find(m => m.Id === k).loaded)
                return false;
        }
        return true;
    }

    /*

        this.getApplicationConfigValue("UCUri").subscribe(result => { this.UriConfig.UCUri = result });
        this.getApplicationConfigValue("GETUri").subscribe(result => { this.UriConfig.GETUri = result });
        this.getApplicationConfigValue("oldUCUri").subscribe(result => { this.UriConfig.oldUCUri = result });
        this.getApplicationConfigValue("oldGETUri").subscribe(result => { this.UriConfig.oldGETUri = result });
    */

    getSearchItems(): SearchItem[] {
        return this._searchItems.map((item, index) => { const searchItem: SearchItem = new SearchItem(); searchItem.Id = item.Id; searchItem.Title = item.Title; searchItem.SearchId = 0; searchItem.SearchStr = ''; return searchItem; });
    }

    showStatus(Id: number, level: number): Observable<boolean> {
        return this.routeCallbackSubject.map(
            message => {
                return this.showMeOrNot(Id, level);
            });
    }
    IsInNewUI(linkId: number, level: number): boolean {
        if (this._newUIRouteIds.findIndex(m => m.linkId === linkId && m.level === level) < 0)
            return false;
        return true;
    }
    setTopMenu(menu: TopMenu) {
        this._topMenu = menu;
        this._menuIsSet = true;
    }

    getTopMenu(): TopMenu {
        return this._topMenu;
    }

    showSerchBox(Id: number, level: number) {

  }

  public SSOEnabled(): Observable<boolean> {
    return this._http.get<boolean>('Api/Application/SSOEnabled').pipe(catchError(this.handleError));
  }

  public getApplicationConfiguration(key: string): Observable<boolean> {
    const options = {
      params: new HttpParams().set('Key', key)
    };
    return this._http.get<boolean>('Api/Application/GetConfiguration', options).pipe(catchError(this.handleError));
  }

    public getApplicationConfigValue(key: string): Observable<any> {
        const options = {
            params: new HttpParams().set('id', key)
        };
        return this._http.get('Api/Application/GetAPPLICATION_LU_CONFIG', options).pipe(catchError(this.handleError));
    }
    public setApplicationConfigValue(applicationConfigValue: string, applicationConfigKey: string): Observable<any> {
        const options = {
            params: new HttpParams().set('Value', applicationConfigValue).set('Key', applicationConfigKey)
        };
        return this._http.post('Api/Application/SetAPPLICATION_LU_CONFIG?Value=' + applicationConfigValue + '&Key=' + applicationConfigKey, "").pipe(catchError(this.handleError));
    }
    public GetLoggedInUserName(): Observable<string> {
        // return this._http.get("Api/User/GetLoggedInUserName")
        //    .share().map(
        //    (response: Response) => <string>response.json()).catch(this.handleError);
       //// return this.getUsername();
      return this._http.get<string>('Api/User/GetLoggedInUserName').pipe(catchError(this.handleError));
    }

    public getUsername(): Observable<string> {
        return this.usernameSubject.asObservable();
    }

    public loadUsername() {
        this._http.get('Api/User/GetLoggedInUserName').pipe(catchError(this.handleError)).subscribe((r: any) => {
            this.usernameSubject.next(r);
        });
    }

    public GetTopMenuForUser(): Observable<TopMenu> {
        return this._http.get<TopMenu>('Api/User/GetTopMenu').pipe(catchError(this.handleError));
    }

    public GetTopMenuForUserAndRoute(rp: string): Observable<TopMenu> {
        const options = {
            params: new HttpParams().set('rp', rp.toString())
        };
        return this._http.get<TopMenu>('Api/User/GetTopMenuForPage', options).pipe(catchError(this.handleError));
    }

    public GetTopMenuForUserAndRouteSP(): Observable<TopMenu> {
        return this._http.get<TopMenu>('Api/User/GetTopMenuForPageSP').pipe(catchError(this.handleError));
    }

    public GetTopMenuForUserAndRoute_BK(rp: string): Observable<TopMenu> {
        const options = {
            params: new HttpParams().set('rp', rp.toString())
        };
        return this._http.get<TopMenu>('Api/User/GetTopMenuForPage_BK', options).pipe(catchError(this.handleError));
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    public getEquipmentList(PageNo: number, PageSize: number): Observable<equipmentVwMdl[]> {
        const options = {
            params: new HttpParams().set('PageNo', PageNo.toString()).set('PageSize', PageSize.toString())
        };
        return this._http.get<equipmentVwMdl[]>('Api/Dashboard/getEquipmentList', options).pipe(catchError(this.handleError));
    }
    public getCustomerListForSelection(PageNo: number, PageSize: number): Observable<Customer[]> {
        const options = {
            params: new HttpParams().set('PageNo', PageNo.toString()).set('PageSize', PageSize.toString())
        };
        return this._http.get<Customer[]>('Api/Application/getCustomerListForSelection', options).pipe(catchError(this.handleError));
    }
    public getJobSiteListForSelection(PageNo: number, PageSize: number): Observable<JobSite[]> {
        const options = {
            params: new HttpParams().set('PageNo', PageNo.toString()).set('PageSize', PageSize.toString())
        };
        return this._http.get<JobSite[]>('Api/Application/getJobSiteListForSelection', options).pipe(catchError(this.handleError));
    }
    public getSiteCode(): Observable<any> {
        return this._http.get('Api/Application/GetSiteCode').pipe(catchError(this.handleError));
    }

    public getApplicationInfoEmail(): Observable<any> {
        return this._http.get('Api/Application/GetInfoEmail').pipe(catchError(this.handleError));
    }
    public getEquipmentListForSelection(PageNo: number, PageSize: number): Observable<Equipment[]> {
        const options = {
            params: new HttpParams().set('PageNo', PageNo.toString()).set('PageSize', PageSize.toString())
        };
        return this._http.get<Equipment[]>('Api/Application/getEquipmentListForSelection', options).pipe(catchError(this.handleError));
    }
    public getEquipmentListForSetup(PageNo: number, PageSize: number): Observable<Equipment[]> {
        const options = {
            params: new HttpParams().set('PageNo', PageNo.toString()).set('PageSize', PageSize.toString())
        };
        return this._http.get<Equipment[]>('Api/Application/getEquipmentListForSetup', options).pipe(catchError(this.handleError));
    }

    public getFamilyListForSelection(PageNo: number, PageSize: number): Observable<Family[]> {
        const options = {
            params: new HttpParams().set('PageNo', PageNo.toString()).set('PageSize', PageSize.toString())
        };
        return this._http.get<Family[]>('Api/Application/getFamilyListForSelection', options).pipe(catchError(this.handleError));
    }
    public getMakeListForSelection(PageNo: number, PageSize: number): Observable<Make[]> {
        const options = {
            params: new HttpParams().set('PageNo', PageNo.toString()).set('PageSize', PageSize.toString())
        };
        return this._http.get<Make[]>('Api/Application/getMakeListForSelection', options).pipe(catchError(this.handleError));
    }
    public getActiveMakeListForSelection(PageNo: number, PageSize: number): Observable<Make[]> {
        const options = {
            params: new HttpParams().set('PageNo', PageNo.toString()).set('PageSize', PageSize.toString())
        };
        return this._http.get<Make[]>('Api/Application/getActiveMakeListForSelection', options).pipe(catchError(this.handleError));
    }
    public getModelListForSelection(PageNo: number, PageSize: number): Observable<Model[]> {
        const options = {
            params: new HttpParams().set('PageNo', PageNo.toString()).set('PageSize', PageSize.toString())
        };
        return this._http.get<Model[]>('Api/Application/getModelListForSelection', options).pipe(catchError(this.handleError));
    }
    public getAllColourSchemes(): Observable<ColourScheme[]> {
        return this._http.get<ColourScheme[]>('Api/Application/GetAllColourSchemes').pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllColourSchemesApiAddress).share().map(
        //     (response: Response) => <ColourScheme[]>response.json()).catch(this.handleError);
    }


    public getAllDealerGroups(): Observable<DealerGroupV[]> {
        return this._http.get<DealerGroupV[]>('Api/Application/GetAllDealerGroupsForUser').pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllDealerGroupsApiAddress).share().map(
        //     (response: Response) => <DealerGroupV[]>response.json()).catch(this.handleError);
    }



    public GetApplicationStyleForDG(DealerGroupId: number): Observable<DealerGroupBrandingV> {
        const options = {
            params: new HttpParams().set('DealerGroupId', DealerGroupId.toString())
        };
        return this._http.get<DealerGroupBrandingV>('api/Application/GetDealerGroupApplicationId', options).pipe(catchError(this.handleError));
    }

    public UpdateDealerGroupBranding(style: DealerGroupBrandingV): Observable<number> {
        return this._http.post<number>('api/Application/UpdateDealerGroupBranding', style).pipe(catchError(this.handleError));
    }

    public getModelList(): Observable<Model[]> {
        return this._http.get<Model[]>('Api/Application/GetModelList',).pipe(catchError(this.handleError));
    }

    // If this component or any of its children are requesting then returns true
    // if this._currentRoute.level < this.level then return false;
    // if this._currentRoute.level > this.level then loop to see if is a parent of this one
    // then return true;
    public showMeOrNot(Id: number, level: number): boolean {
        // If in the same level
        if (this._currentRoute.routeLevel === level) {
            if (this._currentRoute.routeId === Id)
                return true;
            return false;
        }

        // This is a child which is not in the current route level
        if (this._currentRoute.routeLevel < level)
            return false;

        if (!this._menuIsSet) return false;

        // So current level is bigger than requested means this one may be a parent of requested which should be shown

        // now a parent wants to know if should be shown
        // if any of its children is current returns true
        // routeLevel cannot be 1 it is 2 or 3 because level one doesn't have any parent!
        if (this._currentRoute.routeLevel === 2) { // level here is definitely 1
            if (this._topMenu.Divisions[0].levelOneList.findIndex(m => m.Id === Id && m.levelTwoList.findIndex(k => k.Id === this._currentRoute.routeId) > -1) > -1) return true;
        } else if (this._currentRoute.routeLevel === 3 && level === 2) {// level here is 1 or 2
            if (this._topMenu.Divisions[0].levelOneList.findIndex(d => d.levelTwoList.findIndex(m => m.Id === Id && m.levelThreeList.findIndex(k => k.Id === this._currentRoute.routeId) > -1) > -1) > -1)
                return true;
        } else if (this._currentRoute.routeLevel === 3 && level === 1) { // level here is 1 or 2
            if (this._topMenu.Divisions[0].levelOneList.findIndex(m => m.Id === Id && m.levelTwoList.findIndex(k => k.levelThreeList.findIndex(p => p.Id === this._currentRoute.routeId) > -1) > -1) > -1)
                return true;
        }
    }

    public showSearchBoxOrNot(): boolean {
        if (this.showSearchbox.find(m => m.routeId === this._currentRoute.routeId && m.routeLevel === this._currentRoute.routeLevel))
            return true;
        return false;
    }

    public showBreadCrumbOrNot(): boolean {
        if (this._currentRoute.itemId === 9 && this._currentRoute.routeLevel === 1)
            return false;
        if (this._currentRoute.itemId === 1 && this._currentRoute.routeLevel === 3)
            return false;

        return true;
    }

    public getPositionString(Pos: number, CompartTypeId: number): string {
        if (CompartTypeId === 233) // Idler
            if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
        if (CompartTypeId === 234 && Pos === 1) // Carrier roller
            return 'Front';
        if (CompartTypeId >= 230 && CompartTypeId <= 232 || CompartTypeId === 236 || CompartTypeId === 237 || CompartTypeId === 240 || Pos === undefined) // Link, Bushing, Shoe, Sprocket
            return '';
        if (CompartTypeId == 446)
            return 'Rear'
        return Pos.toString();
    }

    public getActionTitle(actionTypeId: number) {
        const action = this.actionTypes.find(m => m.Id === actionTypeId);
        if (!action) return 'Unknown';
        return action.Title;
    }



    getGeneralInspectionInspectors(): Observable<Customer[]> {
        return this._http.get<Customer[]>('api/FindInspection/GetAllGeneralInspectionInspectors').pipe(catchError(this.handleError));
    }

    public getDealerForSelection(PageNo: number, PageSize: number): Observable<Customer[]> {
        const options = {
            params: new HttpParams().set('PageNo', PageNo.toString()).set('PageSize', PageSize.toString())
        };
        return this._http.get<Customer[]>('Api/Application/getDealerListForSelection', options).pipe(catchError(this.handleError));
    }


    public SetDashboardDefaultView(dashboardView: number) {
        const options = {
            params: new HttpParams().set('view', dashboardView.toString())
        };
        return this._http.get('Api/Preferences/SetDashboardDefaultView', options).pipe(catchError(this.handleError));
    }

    public GetDashboardDefaultView() {
        return this._http.get('Api/Preferences/GetDashboardDefaultView').pipe(catchError(this.handleError));
    }

    public GetDeafultUCSetupType() {
        return this._http.get('Api/Preferences/GetUCDefaultType').pipe(catchError(this.handleError));
    }


    //Identity
    toggleMenuVisible() {
        this.menuVisible = !this.menuVisible;
        this.menuVisibleSubject.next(this.menuVisible);
    }

    getMenuVisible(): Observable<boolean> {
        return this.menuVisibleSubject.asObservable();
    }



    getPageTitle(): Observable<string> {
        return this.pageTitleSubject.asObservable();
    }

    setPageSubTitle(pageSubTitle: string) {
        this.pageSubTitleSubject.next(pageSubTitle);
    }

    getPageSubTitle(): Observable<string> {
        return this.pageSubTitleSubject.asObservable();
    }


    public getUndercarriageUrl(): Observable<string> {
        // return this._http.get(this.GetUndercarriageApiAddress).share().map(
        //     (response: Response) => <string>response.json()).catch(this.handleError);
        return this._http.get<string>(this.GetUndercarriageApiAddress).pipe(catchError(this.handleError));
    }

    public getGetUrl(): Observable<string> {
        return this._http.get<string>(this.GetGetApiAddress).pipe(catchError(this.handleError));
        // return this._http.get(this.GetGetApiAddress).share().map(
        //     (response: Response) => <string>response.json()).catch(this.handleError);
    }
    public getLUUCInventoryStatusDropdownList(SystemTypeName: string): Observable<luUCIInventoryStatusModel[]> {

        const options = {
            params: new HttpParams().set('systemTypeName', SystemTypeName)
        };
        return this._http.get<luUCIInventoryStatusModel[]>('Api/Application/GetInventoryStatusDropdownList', options).pipe(catchError(this.handleError));
    }

    public submitFleetReport(body: ReportConfigurationViewModel[]): Observable<any> {
        return this._http.post('Api/Dashboard/submitFleetReport', body).pipe(catchError(this.handleError));
    }

    public recalculateSortOrder(Id: number, sortOrder: number, incrementOrder: number):
        Observable<any> {
        const options = {
            params: new HttpParams().set('Id', Id.toString()).set('SortOrder', sortOrder.toString()).set('IncrementOrder', incrementOrder.toString())
        };
        return this._http.get('Api/Dashboard/RecalculateFleetReportSortOrder', options)
            .pipe(catchError(this.handleError));
    }

    public getEquipmentByCustomerJobsite(customerid: number, jobsiteid: number): Observable<EquipmentModel[]> {
        const options = {
            params: new HttpParams().set('customerid', customerid.toString()).set('jobsiteid', jobsiteid.toString())
        };
        return this._http.get<EquipmentModel[]>('Api/Equipment/GetEquipmentbyCustomerJobsite', options).pipe(catchError(this.handleError));
    }

    public getEquipmentByCustomerJobsiteModel(customerid: number, jobsiteid: number, modelId: number): Observable<EquipmentModel[]> {
        const options = {
            params: new HttpParams().set('customerid', customerid.toString()).set('jobsiteid', jobsiteid.toString()).set('modelid', modelId.toString())
        };
        return this._http.get<EquipmentModel[]>('Api/Equipment/GetEquipmentbyCustomerJobsite', options).pipe(catchError(this.handleError));
    }
    public getFamilyList(CustomerId: string, jobsiteId: string): Observable<Family[]> {
        const options = {
            params: new HttpParams().set('customerId', CustomerId.toString()).set('jobsiteId', jobsiteId.toString())
        };
        return this._http.get<Family[]>('Api/Application/getFamilyList', options).pipe(catchError(this.handleError));
    }

    public getUnitNumberByCustomerFamily(customerId: number, jobsiteId: string): Observable<EquipmentModelVm> {

        const params = new HttpParams()
            .set('customerId', customerId.toString())
            .set('jobsiteId', jobsiteId.toString());

        return this._http.post<EquipmentModelVm>('Api/Dashboard/getUnitNumberByCustomerFamily', null, { params }).pipe(catchError(this.handleError)
        );
    }
    public getVersion(): Observable<string> {
        return this._http.get<string>('Api/Application/GetVersion').pipe(catchError(this.handleError));
    }

    public getMenuItemsCurrentVersion(): Observable<string> {
        return this._http.get<string>('Api/Application/GetMenuItemsCurrentVersion').pipe(catchError(this.handleError));
    }
}
